module.exports = __webpack_public_path__ + "img/gnoken_gnokentokens.058972c.png";